import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AlignSelf from './AlignSelf';
import ClientProvider from './client';
export default createDemo(import.meta.url, AlignSelf, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/flexbox/demos/align-self/AlignSelf.tsx",
    "fileName": "AlignSelf.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function AlignSelf() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'flex-start',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          height: 124,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item sx={{ alignSelf: 'flex-end' }}>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 52,
        "focusedLines": 15,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function AlignSelf() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'flex-start',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          height: 124,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item sx={{ alignSelf: 'flex-end' }}>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "display"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "flex",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "alignItems"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "flex-start",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "background.paper",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "height"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "124"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "borderRadius"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "        }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "alignSelf"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "flex-end",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 3</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 52,
    "focusedLines": 15,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
